import { Divider, Typography } from '@mui/material';
import { PropsWithChildren, ReactNode } from 'react';

import { Root, Left, Center, Right } from './DataGridWidgetHeader.styled';

export interface BaseWidgetHeaderProps {
  title?: ReactNode;
  left?: ReactNode;
  right?: ReactNode;
  center?: ReactNode;
  disablePadding?: boolean;
}

export const DataGridWidgetHeader = ({
  title,
  center,
  right,
  left,
  children,
  disablePadding,
}: PropsWithChildren<BaseWidgetHeaderProps>) => {
  return (
    <Root disablePadding={disablePadding}>
      <Left>
        {title && (
          <Typography
            variant="caption"
            color="textSecondary"
            noWrap
            sx={{
              display: 'block',
            }}
          >
            {title}
          </Typography>
        )}
        {title && left ? <Divider orientation="vertical" sx={{ marginLeft: 3, marginRight: 2 }} /> : null}
        {left}
      </Left>
      <Center>{center}</Center>
      {right ? <Right>{right}</Right> : null}
      {children}
    </Root>
  );
};
